:host {
  display: block;
  max-width: 100%;
}
